<template>
  <fragment>
    <b-row>
      <b-col md="12">
        <ReviewResultForm
          @onSubmit="fetchResult"
          :rwSessions="listReviewSession"
          :group-criteria="listGroupCriteria"
          :users="listUser"
          :isAdmin="isAdmin"
        />
      </b-col>

      <b-col md="12">
        <Heading1 text="List of results">
          <Loader v-if="fetching" size="2rem" />
        </Heading1>
      </b-col>
      <b-col md="12" v-if="!fetching">
        <div role="tablist">
          <ReviewResultShow
            v-for="(rs, idx) in listReviewResult"
            :key="idx"
            :point="rs.avgPoints"
            :comments="rs.comments"
            :index="++idx"
            :question="rs.criteria.title"
          />
        </div>
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import ReviewResultForm from '@/components/ReviewResultForm';
import ReviewResultShow from '@/components/ReviewResultShow';
import Loader from '@/components/Loader';
import Heading1 from '@/components/Heading1';

export default {
  components: { ReviewResultForm, ReviewResultShow, Loader, Heading1 },
  data() {
    return { fetching: false, selectedCriteria: '' };
  },
  computed: {
    ...mapGetters('review', ['listReviewSession', 'listReviewForm', 'listReviewResult']),
    ...mapGetters('criteria', ['listGroupCriteria']),
    ...mapGetters('user', ['listUser']),
    ...mapGetters('app', ['isAdmin']),
  },
  methods: {
    ...mapActions('review', ['fetchListReviewSession', 'fetchListReviewForm', 'fetchListReviewResult']),
    ...mapMutations('review', ['setListReviewResult']),
    ...mapActions('criteria', ['fetchListGroupCriteria']),
    ...mapActions('user', ['fetchListUser']),
    fetchResult(formData) {
      this.fetching = true;
      this.selectedCriteria = formData.groupCriteriaId;
      this.fetchListReviewResult(formData).then(() => {
        this.fetching = false;
      });
    },
  },
  mounted() {
    this.fetchListReviewSession();
    this.fetchListGroupCriteria();
    this.fetchListUser();
  },
  beforeDestroy() {
    this.setListReviewResult([]);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors';

.headline {
  margin-bottom: 1.5rem;
}
.title {
  font-size: 2rem;
  margin-right: 1rem;
  margin-bottom: 0;
  color: $darkBlue;
}
</style>
